<template lang="pug" functional>
  .fixed-width-tweak-upper
    .xs-12.board
      slot
  
</template>

<script>
  export default {
    name: "FixedWidthTweakUpper"
   }
</script>

<style scoped lang="stylus">

</style>